import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import LoginPage from './routes/login';

const HojePage = lazy(() => import('./routes/hoje'));
const ComidaPage = lazy(() => import('./routes/comida'));
const EstoquePage = lazy(() => import('./routes/estoque'));
const AguaPage = lazy(() => import('./routes/agua'));
const TreinoPage = lazy(() => import('./routes/treino'));
const CorridaPage = lazy(() => import('./routes/corrida'));
const EstudoPage = lazy(() => import('./routes/estudo'));
const EstudoSessaoPage = lazy(() => import('./routes/estudo-sessao'));
const CartoesPage = lazy(() => import('./routes/cartoes'));
const RevisaoPage = lazy(() => import('./routes/revisao'));
const ImportarPage = lazy(() => import('./routes/importar'));
const HistoricoPage = lazy(() => import('./routes/historico'));
const ProgressoPage = lazy(() => import('./routes/progresso'));
const CheckinPage = lazy(() => import('./routes/checkin'));
const LembretesPage = lazy(() => import('./routes/lembretes'));
const PerfilPage = lazy(() => import('./routes/perfil'));

/** Rotas da seção 1.4 / 10.1. */
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <HojePage /> },
      { path: '/comida', element: <ComidaPage /> },
      { path: '/comida/estoque', element: <EstoquePage /> },
      { path: '/agua', element: <AguaPage /> },
      { path: '/treino', element: <TreinoPage /> },
      { path: '/treino/corrida', element: <CorridaPage /> },
      { path: '/estudo', element: <EstudoPage /> },
      { path: '/estudo/sessao', element: <EstudoSessaoPage /> },
      { path: '/estudo/cartoes', element: <CartoesPage /> },
      { path: '/estudo/cartoes/importar', element: <ImportarPage /> },
      { path: '/historico', element: <HistoricoPage /> },
      { path: '/progresso', element: <ProgressoPage /> },
      { path: '/progresso/checkin', element: <CheckinPage /> },
      { path: '/lembretes', element: <LembretesPage /> },
      { path: '/perfil', element: <PerfilPage /> },
    ],
  },
  // Revisão: tela cheia, sem barra de abas
  { element: <AppShell tabs={false} />, children: [{ path: '/estudo/revisao', element: <RevisaoPage /> }] },
  { path: '*', element: <Navigate to="/" replace /> },
]);
